var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "user-status"
    },
    [
      _c(
        "div",
        {
          staticClass: "user-status__header",
          class: { "user-status__header--active": _vm.click },
          on: { click: _vm.toggleDropdown }
        },
        [
          _c(
            "div",
            [
              _vm._t("title"),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-angle-down",
                attrs: { "aria-hidden": "true" }
              })
            ],
            2
          ),
          _vm._v(" "),
          !_vm.noImage
            ? _c(
                "div",
                {
                  staticClass: "user-status__image",
                  attrs: { "data-user-status": _vm.userStatus }
                },
                [_vm._t("image")],
                2
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "user-status__content" }, [_vm._t("content")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40e245bb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40e245bb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/UserStatus.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-40e245bb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/UserStatus.vue
// module chunks = 0